// client/src/admin/dashboard/Content.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { TranslateContext } from "../../context/TranslateContext";

import AdminHome from "./AdminHome";
import ManageUsers from "../manage-users/ManageUsers";
import AdminSupportTickets from "../support/AdminSupportTickets";
import InstagramSettings from "../instagram/InstagramSettings";
import FlowBuilder from "../instagram/FlowBuilder";
import FollowClaims from "../instagram/FollowClaims";

const PlaceholderPage = ({ title }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 320,
      gap: 1.5,
    }}
  >
    <span style={{ fontSize: 40 }}>🚧</span>
    <Typography variant="body1" fontWeight={600} color="text.secondary">
      {title}
    </Typography>
    <Typography variant="body2" color="text.disabled">
      This page is under construction
    </Typography>
  </Box>
);

const Content = ({ selectedMenu, addon, menuItems = [] }) => {
  const { lang } = React.useContext(TranslateContext);

  return (
    <div>
      {selectedMenu === "dashboard" && <AdminHome title="Dashboard" />}
      {selectedMenu === "manage-users" && <ManageUsers lang={lang} />}
      {selectedMenu === "support-tickets" && (
        <AdminSupportTickets lang={lang} />
      )}
      {selectedMenu === "instagram-settings" && (
        <InstagramSettings lang={lang} />
      )}
      {selectedMenu === "flow-builder" && <FlowBuilder lang={lang} />}
      {selectedMenu === "follow-claims" && <FollowClaims lang={lang} />}
    </div>
  );
};

export default Content;
